// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3mTjv","rowsWrapper":"style_rowsWrapper__3lj8b","rowWrapper":"style_rowWrapper__3vM5V","text":"style_text__3Nnve"};